interface Props {
  checked: boolean
  onChange: (value: boolean) => void
  label: string
  disabled?: boolean
  hint?: string
}

export function ToggleSwitch({ checked, onChange, label, disabled = false, hint }: Props) {
  return <button
    type="button"
    role="switch"
    aria-checked={checked}
    disabled={disabled}
    className={`switch-row ${checked ? 'checked' : ''}`}
    onClick={() => onChange(!checked)}
  >
    <span className="switch-control" aria-hidden="true"><span /></span>
    <span className="switch-copy"><strong>{label}</strong>{hint && <small>{hint}</small>}</span>
  </button>
}

